import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import StatementPreferencePage, { getDefaultPageUI, getStatementPreferenceItem } from "components/pages/StatementPreferencePage";
import Classes, { Account } from "model";
import { useEffect } from "react";

export default function CaptureEStatementsEnrollDropdown(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    const accountID = Account.getDefaultBrandedAccountByType("checking").id;
    const { key, value } = getStatementPreferenceItem(accountID);

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    .update([ key ], { ...value, selectIsActive: true })
    .submit();

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });

    return <StatementPreferencePage ui={ ui } />
}